import React from 'react'

function Icon({ name, style, title }) {

    return (
        <i className={"icon-" + name} style={style} title={title} ></i>
    )
}

export default Icon;